import{B as z}from"./chunk-BaseElement-QCmfBlzK.js";import{c as M}from"./chunk-constructorio-Di9akExK.js";import{x as i,T as y}from"./chunk-lit-element-CULRVKo8.js";import{c as w}from"./chunk-repeat-CLr2jifB.js";import{t as R}from"./chunk-custom-element-BhZVzxrc.js";import{n as f}from"./chunk-property-BXqvfTtY.js";import"./chunk-constructorio-DDhIvy8f.js";import"./chunk-_commonjsHelpers-Cpj98o6Y.js";import"./chunk-directive-CF8sV3Lr.js";import"./chunk-directive-helpers-R4cBqjor.js";var E=Object.defineProperty,L=Object.getOwnPropertyDescriptor,b=(t,e,a,s)=>{for(var r=s>1?void 0:s?L(e,a):e,o=t.length-1,l;o>=0;o--)(l=t[o])&&(r=(s?l(e,a,r):l(r))||r);return s&&r&&E(e,a,r),r};let g=class extends z{constructor(){super(...arguments),this.textContent="",this.textSort="",this.textFilter="",this.textFrom="",this.textTo="",this.textHideCount="",this.textViewAllCount="",this.textApply="",this.textClearAll="",this.dataResultsGridWithCountOne="",this.dataResultsGridWithCountOther="",this.resultsPerPage=36,this.collectionHandle="",this.collectionsData={},this.facetsCheckboxVisibleLimit=8,this.currentPage=1,this.enableBundle=!1,this._constructorResponseID=0,this._skipUrlUpdate=!1}async connectedCallback(){super.connectedCallback();const t=new URLSearchParams(window.location.search);this.currentPage=Number(t.get("page"))||1,this._skipUrlUpdate=!0,this.fetchProducts(),window.addEventListener("popstate",this.onPopState.bind(this)),await this.updateComplete,this._skipUrlUpdate=!1}disconnectedCallback(){window.removeEventListener("popstate",this.onPopState.bind(this)),super.disconnectedCallback()}async onPopState(){this._skipUrlUpdate=!0;try{const t=new URLSearchParams(window.location.search),e=Number(t.get("page"))||1;e!==this.currentPage&&(this.currentPage=e),await this.fetchProducts()}finally{this._skipUrlUpdate=!1}}async fetchProducts(){try{const t=await this.getPaginatedResults(this.currentPage);if(t){const{results:e,totalPages:a,facets:s,sortOptions:r,totalResults:o}=t;if(!e)return;const l=e&&e.length>0?e.map(n=>{var m,h;return(m=n.data)!=null&&m.handle?{handle:(h=n.data)==null?void 0:h.handle}:{}}):[];this.collectionsData={facets:s,sortOptions:r,cards:l,paginationIds:Array.from({length:a},(n,m)=>m+1),totalResults:o};const p=s==null?void 0:s.find(n=>this.hasName(n)&&n.name==="price");p&&(this._productsMaxPrice=p.max)}}catch(t){console.error("Error fetching browse results:",t)}}hasName(t){return typeof t=="object"&&t!==null&&"name"in t}createSearchParams(t,e){const a={...t,...e&&{sort_by:e}},s=new URLSearchParams;for(const[r,o]of Object.entries(a))Array.isArray(o)?o.forEach(l=>s.append(`filter_${r}`,l)):s.append(`filter_${r}`,o);return s.toString()}updateURLHash(t){if(this._skipUrlUpdate)return;const e=new URLSearchParams(t);this.currentPage>1?e.set("page",this.currentPage.toString()):e.delete("page");const a=e.toString();history.pushState({processedParams:a},"",`${window.location.pathname}${a&&"?".concat(a)}`)}isEmptyObj(t){return Object.keys(t).length===0&&t.constructor===Object}async getPaginatedResults(t=1,e=this.resultsPerPage,a={},s=""){let r={...a},o=s;if(s==""&&this.isEmptyObj(a)){const l=new URLSearchParams(window.location.search),p={};for(const[h,c]of l.entries()){if(!h.startsWith("filter_"))continue;const u=h.replace(/^filter_/,""),$=p[u];$===void 0?p[u]=u==="price"?[c]:c:Array.isArray($)?$.push(c):p[u]=[$,c]}const{sort_by:n,...m}=p;o=Array.isArray(n)?n[0]:n||"",r={...m}}this.isEmptyObj(a)&&s=="relevance"&&(o=""),this.updateURLHash(this.createSearchParams(r,o));try{const l=await M.browse({filterName:"group_id",filterValue:this.collectionHandle,section:"Products",page:t,resultsPerPage:e,filters:r,sortBy:o,sortOrder:o.includes("ascending")?"ascending":"descending"},{enabled:!0,expiryMs:12e4});if(!l.response)return;const p=l.response.results,n=l.response.total_num_results,m=Math.ceil((n??1)/this.resultsPerPage),h=l.response.sort_options,c=l.response.facets;return{results:p,totalPages:m,currentPage:t,facets:c,sortOptions:h,totalResults:n}}catch(l){return console.error("Constructor.io pagination error:",l),null}}async filterChanged(t,e){var $;if(!t)return;const a=e==null?void 0:e.hasAttribute("target-clear-all-filters"),s=(e==null?void 0:e.tagName)==="FACET-REMOVE"&&e.dataset.name=="price";if(e)if(e.id.toLowerCase().includes("mobile")){if(e.getAttribute("type")==="radio"){const d=document.querySelector('select[name="sort_by"]');d&&(d.value=e.value,d.dispatchEvent(new Event("change",{bubbles:!0})))}else{const d=e.id.replace("Mobile","Desktop"),x=document.getElementById(d);x&&(x.getAttribute("type")==="checkbox"?x.checked=e.checked:x.value=e.value,x.dispatchEvent(new Event("change",{bubbles:!0})))}return}else if(e.tagName.toLowerCase()==="select"){const d=document.querySelector(`[type="radio"][name="sort_by"][value="${e.value}"]`);d.checked=!0}else{const d=document.getElementById(e.id.replace("Desktop","Mobile"));d&&(e.type=="checkbox"?d.checked=e.checked:d.value=e.value)}const r=($=t.querySelector("#SortOptionsFormDesktop select"))==null?void 0:$.value;let o=1;const l=t.querySelector("[aria-current='page']");l&&!e&&l.textContent&&(o=parseFloat(l.textContent));const p=parseFloat(t.getAttribute("data-pagination-results-per-page")),n=t.querySelector("[target-filters]"),m=new FormData(n),h={};for(const[d,x]of m.entries())h[d]?Array.isArray(h[d])?h[d].push(x):h[d]=[h[d],x]:h[d]=x;const c={};if(!a){const d=n.querySelector('[name="filter.v.price.gte"]'),x=d?d.getAttribute("min"):null,_=d?d.getAttribute("data-max"):null;let C,P;for(const[F,k]of Object.entries(h))F==="filter.v.price.gte"?typeof k=="string"&&(C=k):F==="filter.v.price.lte"?typeof k=="string"&&(P=k):F!=="sort_by"&&(c[F]=k);if((C&&x&&parseFloat(C)!=parseFloat(x)||P&&_&&parseFloat(P)!=parseFloat(_))&&!s){const F=C??"",k=P??"";c.price=[`${F}-${k}`]}}this.scrollIntoView();const u=await this.getPaginatedResults(o,p,c,r);if(this._constructorResponseID++,u){const{results:d,totalPages:x,facets:_,sortOptions:C,totalResults:P}=u;if(!d)return;const F=_==null?void 0:_.map(v=>({...v,opened:"status"in v&&typeof v.status=="object"&&Object.keys(v.status).length>0||"options"in v&&Array.isArray(v.options)&&v.options.some(S=>S.status!=="")})),k=d&&d.length>0?d.map(v=>{var S,A;return(S=v.data)!=null&&S.handle?{handle:(A=v.data)==null?void 0:A.handle}:{}}):[];this.collectionsData={facets:F,sortOptions:C,cards:k,paginationIds:Array.from({length:x},(v,S)=>S+1),totalResults:P},this.scrollIntoView({behavior:"smooth",block:"start"})}}paginateHandleClick(t){var r,o;const e=t.target,a=(o=(r=e.parentElement)==null?void 0:r.parentElement)==null?void 0:o.querySelectorAll("button:not([data-direction])"),s=parseInt(e==null?void 0:e.textContent);this.currentPage=s,a==null||a.forEach(l=>{var m;const n=parseInt((m=l.querySelector("span"))==null?void 0:m.textContent)==s;l.classList.toggle("border-t-foreground",n),l.classList.toggle("border-t-border",!n),n?(l.setAttribute("aria-current","page"),this.filterChanged(e.closest("collection-results-section"))):l.removeAttribute("aria-current")})}paginateArrowClick(t){var r,o,l,p;const e=t.target,a=(o=(r=e.parentElement)==null?void 0:r.parentElement)==null?void 0:o.querySelector("[aria-current='page']"),s=(p=(l=e.parentElement)==null?void 0:l.parentElement)==null?void 0:p.querySelectorAll("button:not([data-direction])");if(a&&s&&e){const n=Array.from(s).indexOf(a),m=parseFloat(e==null?void 0:e.getAttribute("data-direction"));m>0&&n<s.length-1&&s[n+1].click(),m<0&&n>0&&s[n-1].click()}}applyFilterEvent(t){const e=t.target;this.currentPage=1,this.filterChanged(e.closest("collection-results-section"),e)}clearAllFilters(t){t.preventDefault(),this.applyFilterEvent(t)}handleSelectChange(t){this.applyFilterEvent(t)}handleCheckboxChange(t){this.applyFilterEvent(t)}handleInputChange(t){this.applyFilterEvent(t)}handleize(t){return t.toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/-$/,"").replace(/^-/,"")}getFacetsHTML(t,e,a){var r;const s=t==null?void 0:t.reduce((o,l)=>{const p=l.type!="range"?l.options.filter(n=>n.status==="selected").length:Object.hasOwn(l.status,"min")&&Object.hasOwn(l.status,"max")&&(l.status.min!=l.min||l.status.max<(this._productsMaxPrice||l.max))?1:0;return o+p},0);return i`
      <div class="flex h-full w-full flex-col">
        <div
          class="flex-grow${e=="Mobile"?" overflow-auto":y}"
        >
          ${w(t??[],o=>o.name+e+this._constructorResponseID,o=>i`
              <details
                class="group/details border-b border-t-border"
                ?open="${e!="Mobile"||o.opened||o.type==="range"}"
              >
                <summary
                  class='focus-inset group/filter-dropdown md:after:content-[" "] relative flow-root cursor-pointer max-md:px-xs max-md:py-md md:pointer-events-none md:cursor-auto md:pb-xs md:pt-sm md:after:pointer-events-none md:after:absolute md:after:left-0 md:after:top-0 md:after:z-10 md:after:block md:after:h-full md:after:w-full'
                >
                  <div class="flex w-full items-center justify-between text-sm">
                    <span
                      class="${window.brand=="NG"?"text-t-foreground-secondary font-normal":"font-medium"} text-heading-6 capitalize"
                      >${o.display_name}</span
                    >
                    <span class="hidden group-open/details:block">
                      <svg-icon
                        src="icon-minus"
                        class="block md:hidden"
                        style="--icon-size: 13px;"
                      ></svg-icon>
                    </span>
                    <span class="block group-open/details:hidden">
                      <svg-icon
                        src="icon-plus"
                        class="block md:hidden"
                        style="--icon-size: 13px;"
                      ></svg-icon>
                    </span>
                  </div>
                </summary>
                ${(()=>{var p,n,m,h;const l=o.display_name.toLowerCase();switch(!0){case l.includes("price"):return i`
                        ${o.type==="range"?i`
                              <div
                                class="group/facet max-md:px-xs max-md:pb-md md:pb-sm"
                              >
                                <price-range-slider class="block max-w-[258px]">
                                  <div
                                    class="slider-track relative mx-auto h-1 w-[95%] cursor-pointer rounded-full bg-t-disabled"
                                    data-slider-track
                                  >
                                    <!-- Active track area -->
                                    <div
                                      class="active-track absolute h-1 rounded-full bg-t-accent-01"
                                      data-active-track
                                      style="left: 0%; width: 100%;"
                                    ></div>

                                    <!-- Handles -->
                                    <div
                                      class="min-handle absolute -ml-2.5 -mt-2 h-5 w-5 cursor-grab rounded-full border-2 border-t-foreground bg-t-background shadow-md"
                                      data-min-handle
                                      style="left: 0%;"
                                    ></div>
                                    <div
                                      class="max-handle absolute -ml-2.5 -mt-2 h-5 w-5 cursor-grab rounded-full border-2 border-t-foreground bg-t-background shadow-md"
                                      data-max-handle
                                      style="left: 100%;"
                                    ></div>
                                  </div>

                                  <div class="mt-5 flex items-center gap-3">
                                    <div class="relative flex">
                                      <span
                                        class="field-currency text-body absolute left-2.5 top-2.5 z-10"
                                        >$</span
                                      >
                                      <div class="group flex flex-col gap-2xs">
                                        <div class="group peer relative w-full">
                                          <input
                                            class="body bg-gray-50 remove-arrow peer text-body block h-sm-forms-inputheight w-full appearance-none border border-t-foreground-secondary bg-t-background px-sm-forms-padding py-2.5 !pl-5 pt-sm-forms-padding text-t-foreground rounded-forms-radius group-[[error]]:border-[transparent] group-[[error]]:ring-2 group-[[error]]:ring-u-error focus:border-t-foreground focus:outline-none focus:ring-0 disabled:border-t-border disabled:text-t-border lg:h-lg-forms-inputheight lg:px-lg-forms-padding lg:pt-lg-forms-padding"
                                            placeholder=" "
                                            type="number"
                                            id="${e}-Filter-Price-GTE"
                                            name="filter.v.price.gte"
                                            value="${o.status.min}"
                                            data-pattern="d| |,|."
                                            min="0.00"
                                            max="${(p=this._productsMaxPrice)==null?void 0:p.toFixed(2)}"
                                            data-max="${(n=this._productsMaxPrice)==null?void 0:n.toFixed(2)}"
                                            inputmode="decimal"
                                            @input=${this.handleInputChange}
                                            @change=${this.handleInputChange}
                                          />
                                          <label
                                            for="${e}-Filter-Price-GTE"
                                            class="caption absolute start-sm-forms-padding top-3.5 z-10 hidden origin-[0] -translate-y-2.5 scale-75 transform text-t-foreground-secondary duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:-translate-y-2.5 peer-focus:scale-75 peer-focus:text-t-foreground peer-disabled:text-t-border lg:start-sm-forms-padding rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                                          >
                                            ${this.textFrom}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                    <span
                                      class="text-utility-regular text-t-foreground"
                                      >to</span
                                    >
                                    <div class="relative flex">
                                      <span
                                        class="field-currency text-body absolute left-2.5 top-2.5 z-10"
                                        >$</span
                                      >
                                      <div class="group flex flex-col gap-2xs">
                                        <div class="group peer relative w-full">
                                          <input
                                            class="body bg-gray-50 remove-arrow peer text-body block h-sm-forms-inputheight w-full appearance-none border border-t-foreground-secondary bg-t-background px-sm-forms-padding py-2.5 !pl-5 pt-sm-forms-padding text-t-foreground rounded-forms-radius group-[[error]]:border-[transparent] group-[[error]]:ring-2 group-[[error]]:ring-u-error focus:border-t-foreground focus:outline-none focus:ring-0 disabled:border-t-border disabled:text-t-border lg:h-lg-forms-inputheight lg:px-lg-forms-padding lg:pt-lg-forms-padding"
                                            placeholder=" "
                                            type="number"
                                            id="${e}-Filter-Price-LTE"
                                            name="filter.v.price.lte"
                                            value="${o.status.max}"
                                            data-pattern="d| |,|."
                                            min="0.00"
                                            max="${(m=this._productsMaxPrice)==null?void 0:m.toFixed(2)}"
                                            data-max="${(h=this._productsMaxPrice)==null?void 0:h.toFixed(2)}"
                                            inputmode="decimal"
                                            @input=${this.handleInputChange}
                                            @change=${this.handleInputChange}
                                          />
                                          <label
                                            for="${e}-Filter-Price-LTE"
                                            class="caption absolute start-sm-forms-padding top-3.5 z-10 hidden origin-[0] -translate-y-2.5 scale-75 transform text-t-foreground-secondary duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:-translate-y-2.5 peer-focus:scale-75 peer-focus:text-t-foreground peer-disabled:text-t-border lg:start-sm-forms-padding rtl:peer-focus:left-auto rtl:peer-focus:translate-x-1/4"
                                          >
                                            ${this.textTo}
                                          </label>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </price-range-slider>
                              </div>
                            `:y}
                      `;case l.includes("color"):return i`
                        ${o.type==="multiple"?i`
                              <div
                                id="FacetFiltersForm${e}_details-content_filter.p.m.custom.color_group"
                                sub-section-id="FacetFiltersForm${e}_details-content_filter.p.m.custom.color_group"
                                class="group/facet max-md:px-xs max-md:pb-md md:pb-sm"
                              >
                                <ul
                                  class="list-unstyled space-y-xs md:space-y-2xs"
                                  role="list"
                                >
                                  ${w(o.options,c=>c.value+e,(c,u)=>i`
                                      <li class="py-2xs">
                                        <div class="group/swatch">
                                          <input
                                            type="checkbox"
                                            id="FacetFiltersForm${e}_input_filter.p.m.custom.color_group${u}"
                                            name="${o.name}"
                                            value="${c.value}"
                                            class="sr-only"
                                            .checked=${c.status!=""}
                                            @change=${this.handleCheckboxChange}
                                          />
                                          <label
                                            for="FacetFiltersForm${e}_input_filter.p.m.custom.color_group${u}"
                                            title="gid://shopify/Metaobject/103948976181"
                                            class="text-body flex cursor-pointer items-center gap-x-xs"
                                          >
                                            <span
                                              class="relative block aspect-square max-h-[18px] w-[var(--swatch--size,_2rem)] max-w-[18px] overflow-clip rounded-full border border-solid border-t-border bg-[--swatch--background] bg-cover bg-[position:var(--swatch-focal-point,_initial)] bg-origin-border ring-t-foreground ring-offset-2 transition duration-300 ease-in-out [background-image:var(--swatch--background)] group-focus-within/swatch:ring-2 group-focus-within/swatch:ring-[--swatch--background] group-focus-within/swatch:ring-opacity-50 group-focus-within/swatch:ring-offset-2 group-has-[:disabled]/swatch:opacity-30 group-has-[:checked]/swatch:ring-1"
                                              style="--swatch--background: var(--swatch-${this.handleize(c.display_name)});"
                                            ></span>
                                            <span
                                              class="group-has-[:disabled]/swatch:text-t-disabled"
                                            >
                                              <span aria-hidden="true">
                                                <span class="capitalize"
                                                  >${c.display_name}</span
                                                >
                                              </span>
                                              <span class="sr-only"
                                                >${c.display_name}</span
                                              >
                                            </span>
                                          </label>
                                        </div>
                                      </li>
                                    `)}
                                </ul>
                              </div>
                            `:y}
                      `;case l.includes("review"):return i`
                        ${o.type==="multiple"?i`
                              <div
                                id="FacetFiltersForm${e}_details-content_filter.p.m.custom.rating_tier"
                                sub-section-id="FacetFiltersForm${e}_details-content_filter.p.m.custom.rating_tier"
                                class="group/facet max-md:px-xs max-md:pb-md md:pb-sm"
                              >
                                <ul
                                  class="list-unstyled flex flex-col-reverse gap-y-xs md:gap-y-2xs"
                                  role="list"
                                >
                                  ${w(o.options,c=>c.value+e,(c,u)=>i` <li>
                                        <div
                                          class="group/checkbox inline-flex h-[1.813rem] items-center gap-x-xs"
                                        >
                                          <label
                                            class="relative flex cursor-pointer items-center overflow-clip rounded-[1px]"
                                            for="FacetFiltersForm${e}_input_filter.p.m.custom.rating_tier${u}"
                                          >
                                            <input
                                              type="checkbox"
                                              class="${window.brand=="NG"?"rounded-[2px] border-t-foreground-secondary":"border-blue-gray-200"} peer relative size-4 cursor-pointer appearance-none border transition-all checked:border-t-foreground disabled:border-t-border"
                                              id="FacetFiltersForm${e}_input_filter.p.m.custom.rating_tier${u}"
                                              value="${c.value}"
                                              name="rating_tier"
                                              aria-labelledby="FacetFiltersForm${e}_input_filter.p.m.custom.rating_tier${u}_label"
                                              .checked=${c.status!=""}
                                              @change=${this.handleCheckboxChange}
                                            />
                                            <span
                                              class="${window.brand=="NG"?"bg-t-foreground-secondary":"bg-p-darkest"} pointer-events-none absolute left-2/4 top-2/4 flex size-3 h-full w-full -translate-x-2/4 -translate-y-2/4 items-center justify-center text-p-lightest opacity-0 transition-opacity peer-checked:opacity-100 peer-disabled:border-t-border peer-disabled:text-t-border"
                                            >
                                              <svg-icon
                                                src="icon-checkbox-tick"
                                                class="block"
                                                style="--icon-size: 12px;"
                                              ></svg-icon>
                                            </span>
                                          </label>
                                          <label
                                            class="text-body mt-px cursor-pointer select-none text-t-foreground group-has-[:disabled]/checkbox:pointer-events-none group-has-[:disabled]/checkbox:text-t-border"
                                            for="FacetFiltersForm${e}_input_filter.p.m.custom.rating_tier${u}"
                                          >
                                            <div>
                                              <p
                                                id="FacetFiltersForm${e}_input_filter.p.m.custom.rating_tier${u}_label"
                                                class="text-body block leading-none text-t-foreground group-has-[:disabled]/checkbox:text-t-disabled"
                                              >
                                                <span aria-hidden="true">
                                                </span>
                                              </p>
                                              <div
                                                class="flex items-center gap-xs group-has-[:disabled]/checkbox:opacity-50"
                                              >
                                                <div
                                                  class="${window.brand=="TFC"?"gap-[0.063rem]":"gap-1"} flex items-center"
                                                >
                                                  ${w([1,2,3,4,5],$=>"star"+$+e,$=>$<=parseFloat(c.value)?i`<svg-icon
                                                            src="icon-star-full"
                                                            class="block text-t-accent-01"
                                                            style="--icon-size: 16px;"
                                                          ></svg-icon>`:i`<svg-icon
                                                            src="icon-star-empty"
                                                            class="${window.brand=="NG"?"text-t-disabled":"text-t-foreground-secondary"} block"
                                                            style="--icon-size: 16px;"
                                                          ></svg-icon>`)}
                                                </div>
                                              </div>

                                              <span class="sr-only"
                                                >${c.value}
                                              </span>
                                              <p></p>
                                            </div>
                                          </label>
                                        </div>
                                      </li>`)}
                                </ul>
                              </div>
                            `:y}
                      `;default:return i`
                        ${o.type==="multiple"?i`
                              <div
                                class="group/facet max-md:px-xs max-md:pb-md md:pb-sm"
                              >
                                <ul
                                  class="list-unstyled space-y-2xs"
                                  role="list"
                                >
                                  ${w(o.options,c=>c.value,(c,u)=>i` <li
                                        class=${u>=this.facetsCheckboxVisibleLimit?'group-has-[toggle-button[data-toggled="false"]]/facet:hidden':""}
                                      >
                                        <div
                                          class="group/checkbox inline-flex items-center justify-start gap-x-xs"
                                        >
                                          <label
                                            class="relative flex cursor-pointer items-center overflow-clip rounded-[1px]"
                                            for="Filter-filter.p.${this.handleize(c.display_name)}-${e}-${u}"
                                          >
                                            <input
                                              type="checkbox"
                                              class="${window.brand=="NG"?"rounded-[2px] border-t-foreground-secondary":"border-blue-gray-200"} peer relative size-4 cursor-pointer appearance-none border transition-all checked:border-t-foreground disabled:border-t-border"
                                              id="Filter-filter.p.${this.handleize(c.display_name)}-${e}-${u}"
                                              value="${c.value}"
                                              name="${o.name}"
                                              aria-labelledby="Filter-filter.p.${this.handleize(c.display_name)}-${e}-${u}_label"
                                              .checked=${c.status!==""}
                                              @change=${this.handleCheckboxChange}
                                            />
                                            <span
                                              class="${window.brand=="NG"?"bg-t-foreground-secondary":"bg-p-darkest"} pointer-events-none absolute left-2/4 top-2/4 flex size-3 h-full w-full -translate-x-2/4 -translate-y-2/4 items-center justify-center text-p-lightest opacity-0 transition-opacity peer-checked:opacity-100 peer-disabled:border-t-border peer-disabled:text-t-border"
                                            >
                                              <svg-icon
                                                src="icon-checkbox-tick"
                                                class="block"
                                                style="--icon-size: 12px;"
                                              ></svg-icon>
                                            </span>
                                          </label>
                                          <label
                                            class="text-body mt-px cursor-pointer select-none break-all capitalize text-t-foreground group-has-[:disabled]/checkbox:text-t-border"
                                            for="Filter-filter.p.${this.handleize(c.display_name)}-${e}-${u}"
                                          >
                                            ${c.display_name}
                                          </label>
                                        </div>
                                      </li>`)}
                                </ul>
                                ${o.options.length>this.facetsCheckboxVisibleLimit?i`
                                      <toggle-button
                                        role="button"
                                        data-toggled="false"
                                        class="group/toggle-button ${window.brand=="NG"?"text-t-foreground-secondary font-bold":"text-t-foreground"} text-utility-bold mt-md underline md:mt-xs"
                                      >
                                        <span
                                          class='group-data-[toggled="true"]/toggle-button:hidden'
                                          >${this.textViewAllCount.replace("{{ count }}",`${o.options.length}`)}</span
                                        >
                                        <span
                                          class='group-data-[toggled="false"]/toggle-button:hidden'
                                          >${this.textHideCount.replace("{{ count }}",`${o.options.length-this.facetsCheckboxVisibleLimit}`)}</span
                                        >
                                      </toggle-button>
                                    `:y}
                              </div>
                            `:y}
                      `}})()}
              </details>
            `)}
        </div>
        ${e=="Mobile"?i`
              <div
                class="group/toggle-clear-all flex w-full flex-col items-center justify-center gap-xs border-t border-t-border bg-t-background px-pagegridmargin py-sm"
                data-show-clear-all=${(s??0)>0}
              >
                <dialog-toggle modal-id="${a}" class="w-full">
                  <button class="btn w-full" variant="primary">
                    ${((r=this.textApply)==null?void 0:r.replace("{{ count }}",(s==null?void 0:s.toString())??""))??""}
                  </button>
                </dialog-toggle>
                <button
                  class='text-utility-bold block cursor-pointer text-t-foreground underline group-data-[show-clear-all="false"]/toggle-clear-all:hidden'
                  target-clear-all-filters
                  @click=${this.clearAllFilters}
                >
                  ${this.textClearAll}
                </button>
              </div>
            `:y}
      </div>
    `}getSortHTML(t,e){return i`
      ${e=="Desktop"?i` <facet-filters-form
            section-id="facet-filters"
            data-mode="sort"
            class="max-md:hidden"
          >
            <form
              id="SortOptionsForm${e}"
              class="gap-2xs${window.brand=="TFC"?" !font-normal":""} text-utility-bold flex"
            >
              <label for="SortBy">${this.textSort}:</label>
              <div class="relative">
                <select
                  name="sort_by"
                  id="SortBy"
                  class="outline-none${window.brand=="TFC"?" bg-transparent":""} block w-full appearance-none pr-sm"
                  @change=${this.handleSelectChange}
                >
                  ${w(t??[],a=>a.sort_by+e+this._constructorResponseID,a=>i`
                      <option
                        value="${a.sort_by}"
                        ?selected=${a.status!=""}
                      >
                        ${a.display_name.replace("Most Relevant","Featured")}
                      </option>
                    `)}
                </select>
                <svg-icon
                  src="icon-select-arrow"
                  class="pointer-events-none absolute right-0 top-2/4 -translate-y-2/4"
                  style="--icon-size: 16px;"
                ></svg-icon>
              </div>
            </form>
          </facet-filters-form>`:i` <facet-filters-form
            section-id="facet-filters"
            data-mode="sort"
            class="flex h-full"
          >
            <form
              id="SortOptionsForm${e}"
              class="flex w-full flex-col"
            >
              <div
                id="SortOptionsForm${e}_sort"
                class="group/facet max-md:px-pagegridmargin max-md:py-md md:pb-sm"
                sub-section-id="SortOptionsForm${e}_sort"
                data-sort-by="title-ascending"
              >
                <ul class="list-unstyled space-y-xs md:space-y-2xs" role="list">
                  ${w(t??[],a=>a.sort_by+e,a=>i`
                      <li class="py-2xs" data-selected="false">
                        <div
                          class="group/radio inline-flex items-start justify-start gap-x-xs"
                        >
                          <div
                            class="peer relative flex cursor-pointer items-center rounded-full"
                          >
                            <input
                              type="radio"
                              class="peer relative size-4 cursor-pointer appearance-none rounded-full border border-t-foreground-secondary text-t-foreground-secondary transition-all checked:border-t-foreground-secondary disabled:border-t-border"
                              id="sortoptionsform${e}_input_${a.sort_by}"
                              name="sort_by"
                              value="${a.sort_by}"
                              @change=${this.handleSelectChange}
                              .checked=${a.status!=""}
                            />
                            <span
                              class="pointer-events-none absolute left-2/4 top-2/4 -translate-x-2/4 -translate-y-2/4 scale-0 text-t-foreground opacity-0 transition-[opacity,transform-] peer-checked:scale-100 peer-checked:opacity-100"
                            >
                              <svg-icon
                                src="icon-radio-circle"
                                class="block"
                                style="--icon-size: 10px;"
                              ></svg-icon>
                            </span>
                          </div>
                          <label
                            class="mt-px cursor-pointer select-none"
                            for="sortoptionsform${e}_input_new-arrivals8"
                          >
                            <div>
                              <p
                                id="sortoptionsform${e}_input_new-arrivals8_label"
                                class="text-body block leading-none text-t-foreground group-has-[:disabled]/radio:text-t-disabled"
                              >
                                ${a.display_name.replace("Most Relevant","Featured")}
                              </p>
                            </div>
                          </label>
                        </div>
                      </li>
                    `)}
                </ul>
              </div>
            </form>
          </facet-filters-form>`}
    `}getPaginationArray(t,e){const s=[];if(s.push("1"),e<=6)for(let r=2;r<e;r++)s.push(r);else if(t<=3){for(let r=2;r<=4;r++)s.push(r);s.push("...")}else if(t>=e-2){s.push("...");for(let r=e-3;r<e;r++)s.push(r)}else s.push("..."),s.push(t-1),s.push(t),s.push(t+1),s.push("...");return s[s.length-1]!==e&&s.push(e),s.map(r=>r.toString())}getPaginateHTML(t,e=1){if(!t)return;const a=this.getPaginationArray(e,t.length);if(a)return i`
      ${(t==null?void 0:t.length)>1?i`
            <div class="flex justify-center px-lg pb-lg pt-md">
              <ul
                class="flex list-none items-center justify-center gap-2.5"
                role="list"
              >
                ${(t==null?void 0:t.length)>1?i`
                      <li class="inline-flex list-none">
                        <button
                          class="${e===1?"cursor-not-allowed opacity-40":""} flex h-11 items-center justify-center"
                          data-direction="-1"
                          ?disabled=${e===1}
                          aria-disabled="${e===1}"
                          @click=${this.paginateArrowClick}
                        >
                          <svg-icon
                            src=${window.brand==="TFC"?"icon-arrow-curved":"icon-caret"}
                            class="block${window.brand==="TFC"?" text-t-accent-01":""} pointer-events-none"
                            style="--icon-size: 16px;${window.brand==="TFC"?"":" rotate: 90deg;"}"
                          ></svg-icon>
                        </button>
                      </li>
                    `:y}
                ${w(a,s=>"productPage"+s,s=>i`
                    ${s!="..."?i`
                          <li class="inline-flex list-none">
                            <button
                              class="${s==e.toString()?`${window.brand=="NG"?"border-t-foreground-secondary bg-t-accent-04":"border-t-foreground"}`:"border-t-border"} ${window.brand=="NG"?"rounded-full":"rounded-sm"} flex h-11 w-11 items-center justify-center border"
                              aria-current="${s==e.toString()?"page":y}"
                              @click=${this.paginateHandleClick}
                            >
                              <span class="utility-standard pointer-events-none"
                                >${s}</span
                              >
                            </button>
                          </li>
                        `:i`
                          <li class="inline-flex list-none">
                            <span
                              class="${window.brand=="NG"?"rounded-full":"rounded-sm"} flex h-11 w-11 items-center justify-center border border-t-border"
                            >
                              <span class="utility-standard pointer-events-none"
                                >…</span
                              >
                            </span>
                          </li>
                        `}
                  `)}
                ${(t==null?void 0:t.length)>1?i`
                      <li class="inline-flex list-none">
                        <button
                          class="${e===t.length?"cursor-not-allowed opacity-40":""} flex h-11 items-center justify-center"
                          data-direction="1"
                          ?disabled=${e===t.length}
                          aria-disabled="${e===t.length}"
                          @click=${this.paginateArrowClick}
                        >
                          <svg-icon
                            src=${window.brand==="TFC"?"icon-arrow-curved":"icon-caret"}
                            class="block${window.brand==="TFC"?" text-t-accent-01":""} pointer-events-none"
                            style="--icon-size: 16px;${window.brand==="TFC"?" rotate: 180deg;":" rotate: -90deg;"}"
                          ></svg-icon>
                        </button>
                      </li>
                    `:y}
              </ul>
            </div>
          `:y}
    `}removeFacet(t){const e=t.target;if(e.dataset.name=="price")this.currentPage=1,this.filterChanged(e.closest("collection-results-section"),e);else{const a=this.querySelector(`[target-filters][is-mobile] [name="${e.dataset.name}"][value="${e.dataset.value}"]`);a&&a.click()}}getFacetRemove(t,e){return i`
      <facet-remove
        class="flex cursor-pointer snap-center items-center gap-2xs whitespace-nowrap rounded-sm bg-t-background-secondary px-xs py-[0.438rem]"
        data-name="${t.name}"
        data-value="${t.display_name}"
        @click=${this.removeFacet}
      >
        <svg-icon
          src="icon-close"
          class="pointer-events-none block"
          style="--icon-size: 8px"
        ></svg-icon>
        <span
          class="text-utility-regular pointer-events-none text-t-foreground"
        >
          ${t.type=="range"?i`$${t.min} - $${t.max}`:t.name=="rating_tier"?i`
                  <div class="flex items-center gap-1">
                    ${w([1,2,3,4,5],a=>"star"+a+e,a=>a<=parseFloat(t.display_name)?i`<svg-icon
                              src="icon-star-full"
                              class="block text-t-accent-01"
                              style="--icon-size: 16px;"
                            ></svg-icon>`:i`<svg-icon
                              src="icon-star-empty"
                              class="block text-t-foreground-secondary"
                              style="--icon-size: 16px;"
                            ></svg-icon>`)}
                  </div>
                `:i`${t.display_name}`}
        </span>
      </facet-remove>
    `}getFilteredFacets(t,e){if(!(t!=null&&t.length))return i``;const a=(t==null?void 0:t.reduce((s,r)=>{if(r.type!=="range"){const o=r.options.filter(l=>l.status==="selected").map(l=>({...l,name:r.name}));return s.concat(o)}else{const o=Object.hasOwn(r.status,"min")&&Object.hasOwn(r.status,"max"),l=r.status.min!==r.min,p=r.status.max<(this._productsMaxPrice??r.max);return o&&(l||p)&&s.push({...r,min:r.status.min,max:r.status.max}),s}},[]))??[];return i`
      <div
        class="empty:pt-0${e=="Desktop"?" max-md:hidden":""} col-span-full w-full pt-sm empty:hidden"
        data-target-facet-removes="${e==null?void 0:e.toLowerCase()}"
      >
        ${a.length>0?i` <facet-filters-form
              section-id="facet-filters"
              class="[&amp;[loading]]:opacity-50 [&amp;[loading]]:pointer-events-none flex h-full w-full"
              data-mode="facet-removes"
              data-form-id="FacetRemovesForm${e}"
              data-filters-form-id="FacetFiltersForm${e}"
            >
              <form
                id="FacetRemovesForm${e}"
                class="${e=="Desktop"?"flex-wrap":"no-scrollbar overflow-x-auto snap-x snap-mandatory px-xs"} flex w-full items-center gap-2xs"
              >
                ${w(a??[],s=>s.name,s=>this.getFacetRemove(s,e))}
                ${e=="Desktop"?i`<facet-remove
                      class="text-utility-bold ml-2xs cursor-pointer text-t-foreground underline"
                      target-clear-all-filters
                      @click=${this.clearAllFilters}
                    >
                      ${this.textClearAll}
                    </facet-remove>`:y}
              </form>
            </facet-filters-form>`:y}
      </div>
    `}getModalDialog(t,e,a,s,r,o,l,p,n,m){return i`
      <modal-dialog
        cloak
        type="${r}"
        id="${t}"
        anchor="${e}"
        close-on-backdrop-click="true"
        drawer-classes="${n}"
        header-classes="${m}"
        close-icon-size="${l}"
      >
        <h5 slot="header" class="${p} h6">${o}</h5>
        <div slot="additional-content">${s}</div>
        <form target-filters is-mobile class="h-full">${a}</form>
      </modal-dialog>
    `}render(){var t,e,a,s,r,o,l,p;return i`<collection-results-section
      class="grid grid-cols-1 px-pagegridmargin pb-sm 2xl:container max-md:px-0 md:grid-cols-[minmax(0,295px)_minmax(0,1fr)] md:gap-x-lg md:gap-y-xs"
      data-pagination-results-per-page="${this.resultsPerPage}"
      target-content-results
      data-cnstrc-browse
      data-cnstrc-filter-name="group_id"
      data-cnstrc-filter-value="${this.collectionHandle}"
      data-cnstrc-num-results="${((t=this.collectionsData)==null?void 0:t.totalResults)??0}"
      data-loaded="${!!this.collectionsData.cards}"
      style="content-visibility: auto; contain-intrinsic-size: 0 2000px;"
    >
      ${this.getFilteredFacets(this.collectionsData.facets,"Desktop")}
      <aside class="md:block md:pb-6">
        <div class="max-md:hidden">
          <form target-filters>
            ${this.getFacetsHTML(this.collectionsData.facets,"Desktop")}
          </form>
        </div>

        ${this.getModalDialog("filter-drawer-dialog-content","left",this.getFacetsHTML(this.collectionsData.facets,"Mobile","filter-drawer-dialog-content"),this.getFilteredFacets(this.collectionsData.facets,"Mobile"),"drawer",this.textFilter,13,"!h4","!max-w-[22.5rem] !overflow-clip !text-t-foreground","!px-0 !py-md [&_.title-container]:!px-xs")}
        ${this.getModalDialog("sort-options-drawer-dialog-content","left",this.getSortHTML((e=this.collectionsData)==null?void 0:e.sortOptions,"Mobile"),i``,"drawer",this.textSort,13,"!h4","!max-w-[22.5rem]")}
      </aside>

      <div class="flex-grow" content-category-results="resources">
        <div>
          <div>
            <div
              id="content-grid-header-search"
              class="product-grid-header mb-sm flex flex-col md:mt-sm md:flex-row md:items-center md:justify-between md:gap-sm"
            >
              <div
                class="flex${window.brand=="NG"?" max-md:bg-t-background-secondary":""}"
              >
                <dialog-toggle
                  modal-id="filter-drawer-dialog-content"
                  class="w-full md:hidden"
                >
                  <button
                    class="flex h-button-height w-full items-center justify-center gap-2xs border border-t-border text-t-foreground"
                    aria-expanded="false"
                  >
                    <svg-icon
                      src="icon-filters"
                      class="block"
                      style="--icon-size: 25px;"
                    ></svg-icon>
                    <span class="text-utility-bold font-medium"
                      >${this.textFilter}</span
                    >
                  </button>
                </dialog-toggle>
                <dialog-toggle
                  modal-id="sort-options-drawer-dialog-content"
                  class="w-full md:hidden"
                >
                  <button
                    class="flex h-button-height w-full items-center justify-center gap-2xs border-y border-r border-t-border text-t-foreground"
                    aria-expanded="false"
                  >
                    <svg-icon
                      src="icon-sorting"
                      class="block"
                      style="--icon-size: 25px;"
                    ></svg-icon>
                    <span class="text-utility-bold font-medium"
                      >${this.textSort}</span
                    >
                  </button>
                </dialog-toggle>
                ${this.getSortHTML((a=this.collectionsData)==null?void 0:a.sortOptions,"Desktop")}
              </div>
              <span
                class="${window.brand=="NG"?"text-t-disabled":"text-t-foreground-secondary"} text-utility-regular max-md:mb-2xs max-md:mt-sm max-md:w-full max-md:px-pagegridmargin md:order-[-1]"
              >
                ${(s=this.collectionsData)!=null&&s.totalResults?(((r=this.collectionsData)==null?void 0:r.totalResults)==1?this.dataResultsGridWithCountOne:this.dataResultsGridWithCountOther).replace("{{ count }}",`${(l=(o=this.collectionsData)==null?void 0:o.totalResults)==null?void 0:l.toLocaleString("en-US")}`):y}
              </span>
            </div>
            <div>
              <div
                class="grid grid-cols-2 gap-x-xs gap-y-md max-md:px-pagegridmargin lg:grid-cols-4 lg:gap-y-7"
              >
                ${w(((p=this.collectionsData)==null?void 0:p.cards)??[],n=>n.handle,n=>i`
                    <dynamic-product-card
                      handle="${n.handle}"
                      class="group/dynamic-product-card"
                      query-params="${this.collectionHandle.includes("free")&&this.collectionHandle.includes("samples")?"free-sample=true":""}"
                      template="${this.enableBundle?"product-card--bundle-cta":"product-card"}"
                    >
                      <div
                        data-slot="product-card-skeleton"
                        class="relative flex w-full flex-col group-has-[a]/dynamic-product-card:hidden"
                      >
                        <div
                          data-slot="product-card-skeleton-image"
                          class="${window.brand=="NG"?"rounded-sm":""} block aspect-square animate-pulseskeleton overflow-clip bg-t-border"
                        ></div>
                        <div class="flex flex-col gap-2xs pt-2.5">
                          <div
                            data-slot="product-card-skeleton-title"
                            class="${window.brand=="NG"?"rounded-sm":""} ${window.brand=="TFC"||window.brand=="WSP"?"pb-px":""} text-heading-6 box-content h-[1lh] max-w-[90%] animate-pulseskeleton bg-t-border font-medium leading-[1.2]"
                          ></div>
                          <div
                            data-slot="product-card-skeleton-reviews"
                            class="${window.brand=="NG"?"rounded-sm":""} mt-2xs h-2.5 max-w-[3.75rem] animate-pulseskeleton bg-t-border"
                          ></div>
                          <div
                            data-slot="product-card-skeleton-price"
                            class="${window.brand=="NG"?"rounded-sm":""} text-utility-regular mt-2xs h-[1lh] max-w-[7.75rem] animate-pulseskeleton bg-t-border"
                          ></div>
                        </div>
                      </div>
                    </dynamic-product-card>
                  `)}
              </div>
            </div>
            ${this.getPaginateHTML(this.collectionsData.paginationIds,this.currentPage)}
          </div>
        </div>
      </div>
    </collection-results-section>`}};b([f({type:String,attribute:"data-content"})],g.prototype,"textContent",2);b([f({type:String,attribute:"data-sort"})],g.prototype,"textSort",2);b([f({type:String,attribute:"data-filter"})],g.prototype,"textFilter",2);b([f({type:String,attribute:"data-from"})],g.prototype,"textFrom",2);b([f({type:String,attribute:"data-to"})],g.prototype,"textTo",2);b([f({type:String,attribute:"data-hide-count"})],g.prototype,"textHideCount",2);b([f({type:String,attribute:"data-view-all-count"})],g.prototype,"textViewAllCount",2);b([f({type:String,attribute:"data-apply"})],g.prototype,"textApply",2);b([f({type:String,attribute:"data-clear-all"})],g.prototype,"textClearAll",2);b([f({type:String,attribute:"data-results-grid-with-count-one"})],g.prototype,"dataResultsGridWithCountOne",2);b([f({type:String,attribute:"data-results-grid-with-count-other"})],g.prototype,"dataResultsGridWithCountOther",2);b([f({type:Number,attribute:"data-products-per-page"})],g.prototype,"resultsPerPage",2);b([f({type:String,attribute:"data-handle"})],g.prototype,"collectionHandle",2);b([f({type:Object})],g.prototype,"collectionsData",2);b([f({type:Number})],g.prototype,"facetsCheckboxVisibleLimit",2);b([f({type:Number})],g.prototype,"currentPage",2);b([f({type:Boolean,attribute:"enable-bundle"})],g.prototype,"enableBundle",2);g=b([R("collection-results")],g);
